import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Pancake",
        price: 10,
        disprice: 7,
        stock: 4,
        content: "Fluffy, golden pancakes made fresh with premium ingredients—perfect for breakfast or a sweet snack anytime.",
        description: "Our classic Pancakes are soft, airy, and cooked to perfection. Made with fresh dairy, farm eggs, and just the right amount of sweetness. Enjoy them plain or customize with toppings like maple syrup, berries, or chocolate chips. Perfect for a delightful morning start or a comforting afternoon treat.",
        category: ["Sweet Treats", "Bakery Items"],
        tags: ["sweet", "baked", "classic"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "2 pieces" },
            { id: 2, title: "Main Ingredients", content: "Flour, Milk, Eggs, Sugar" },
            { id: 3, title: "Preparation Time", content: "15 minutes" },
            { id: 4, title: "Allergens", content: "Contains Gluten & Dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Parker",
                date: "June 2, 2025",
                rating: 5,
                content: "Absolutely delicious! Soft and fluffy, just how I like my pancakes."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Ryan Smith",
                date: "June 5, 2025",
                rating: 4.5,
                content: "Tastes great with maple syrup. A perfect weekend breakfast."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Smoothie",
        price: 12,
        disprice: 9,
        stock: 9,
        content: "Refreshing fruit smoothie packed with natural flavors and nutrients, perfect for a quick energy boost.",
        description: "Our smoothies are blended fresh with hand-picked fruits and natural yogurt, offering a creamy and refreshing drink. Available in a variety of flavors like strawberry-banana, mango, and mixed berry, each smoothie is packed with vitamins and antioxidants to energize your day.",
        category: ["Healthy Beverages", "Dessert Delights"],
        tags: ["sweet", "fruit", "classic"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "400 ml" },
            { id: 2, title: "Main Ingredients", content: "Mixed Fruits, Yogurt, Honey" },
            { id: 3, title: "Preparation Time", content: "5 minutes" },
            { id: 4, title: "Allergens", content: "Contains Dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sophia Lee",
                date: "June 10, 2025",
                rating: 5,
                content: "Super fresh and tasty! Loved the mango smoothie."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Jason Patel",
                date: "June 12, 2025",
                rating: 4,
                content: "Refreshing and perfect for a hot day. Could be a bit sweeter though."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Sandwich",
        price: 12,
        disprice: 10,
        stock: 10,
        content: "A hearty and delicious sandwich made with fresh ingredients, perfect for a quick and satisfying meal.",
        description: "Our sandwiches are crafted using fresh-baked bread, premium deli meats, crisp vegetables, and signature sauces. Choose from classic flavors like turkey & cheese, grilled chicken, or veggie delight, all made to order for maximum freshness and taste.",
        category: ["Savory Snacks", "Bakery Items"],
        tags: ["classic", "baked", "sweet"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "1 Sandwich" },
            { id: 2, title: "Main Ingredients", content: "Bread, Cheese, Lettuce, Chicken/Turkey" },
            { id: 3, title: "Preparation Time", content: "10 minutes" },
            { id: 4, title: "Allergens", content: "Contains Gluten, Dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Emma Watson",
                date: "June 15, 2025",
                rating: 5,
                content: "Tastes fresh and flavorful! Loved the grilled chicken option."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Noah Ali",
                date: "June 16, 2025",
                rating: 4.5,
                content: "Perfect lunch choice. The bread was soft and fresh."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Bread",
        price: 12,
        disprice: 8,
        stock: 0,
        content: "Freshly baked bread with a golden crust and soft, fluffy interior, perfect for breakfast, sandwiches, or to accompany any meal.",
        description: "Our bread is crafted from high-quality flour and baked daily for ultimate freshness. Whether it's classic white bread, whole wheat, or multigrain, each loaf is made using time-tested techniques for the perfect texture and taste. Ideal for toast, sandwiches, and your favorite recipes.",
        category: ["Bakery Items", "Savory Snacks"],
        tags: ["baked", "classic", "sweet"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Loaf Size", content: "500g" },
            { id: 2, title: "Main Ingredients", content: "Flour, Yeast, Salt, Water" },
            { id: 3, title: "Baking Method", content: "Oven Baked" },
            { id: 4, title: "Shelf Life", content: "2-3 Days" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Adeel Khan",
                date: "June 20, 2025",
                rating: 5,
                content: "Soft inside with a perfect crust. Great for my morning toast."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Sarah Ahmed",
                date: "June 21, 2025",
                rating: 4.5,
                content: "Tastes fresh and homemade. Loved it with butter and jam."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Macaroon",
        price: 12,
        disprice: 10,
        stock: 8,
        content: "Delicate and colorful macaroon cookies with crisp shells and creamy fillings, perfect for an elegant treat.",
        description: "Our macaroons are crafted with almond flour, egg whites, and fine sugar, then filled with rich buttercream or ganache in a variety of flavors like raspberry, chocolate, pistachio, and vanilla. Perfect for tea parties, gifts, or a sweet indulgence anytime.",
        category: ["Sweet Treats", "Dessert Delights"],
        tags: ["sweet", "baked", "classic"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavors Available", content: "Raspberry, Chocolate, Vanilla, Pistachio" },
            { id: 2, title: "Allergens", content: "Contains Nuts, Eggs" },
            { id: 3, title: "Serving Size", content: "Box of 6 or 12 pieces" },
            { id: 4, title: "Shelf Life", content: "3-4 Days (Refrigerated)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Zara Malik",
                date: "June 23, 2025",
                rating: 5,
                content: "Absolutely loved the raspberry flavor. Perfect texture and taste!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Omar Siddiqui",
                date: "June 24, 2025",
                rating: 4.5,
                content: "Beautiful presentation and delicious taste. Will buy again."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Brownie",
        price: 11,
        disprice: 9,
        stock: 5,
        content: "Rich and fudgy brownies with a crackly top, perfect for chocolate lovers craving a decadent dessert.",
        description: "Our brownies are baked using premium dark chocolate, butter, and fresh eggs to achieve a perfect balance of chewy and gooey textures. Whether enjoyed plain or topped with nuts or caramel drizzle, they offer a truly indulgent experience for any occasion.",
        category: ["Dessert Delights", "Sweet Treats"],
        tags: ["chocolate", "baked", "sweet"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Main Ingredients", content: "Dark Chocolate, Butter, Eggs, Flour" },
            { id: 2, title: "Portion Size", content: "Single or Box of 4" },
            { id: 3, title: "Allergens", content: "Contains Eggs, Gluten" },
            { id: 4, title: "Shelf Life", content: "5-7 Days (Room Temperature)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ali Raza",
                date: "June 26, 2025",
                rating: 5,
                content: "Best brownies I've had in a long time. Moist, rich, and so chocolatey!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Hina Farooq",
                date: "June 27, 2025",
                rating: 4.5,
                content: "Perfect with coffee. Loved the texture and taste."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Pie",
        price: 15,
        disprice: 11,
        stock: 3,
        content: "Flaky, buttery crust filled with sweet or savory goodness, perfect for any occasion.",
        description: "Our handcrafted pies are made with a golden, flaky crust and packed with flavorful fillings. Choose from classic apple, berry medley, or rich chocolate cream. Each pie is baked fresh and makes a delightful addition to your dessert table or a comforting snack any time of day.",
        category: ["Dessert Delights", "Bakery Items"],
        tags: ["fruit", "baked", "sweet"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavors", content: "Apple, Berry, Chocolate Cream" },
            { id: 2, title: "Crust Type", content: "Buttery Flaky Crust" },
            { id: 3, title: "Allergens", content: "Contains Gluten, Dairy" },
            { id: 4, title: "Shelf Life", content: "3-4 Days (Refrigerated)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Fatima Noor",
                date: "June 28, 2025",
                rating: 5,
                content: "The apple pie was heavenly! Perfect balance of sweet and tart."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Usman Sheikh",
                date: "June 29, 2025",
                rating: 4,
                content: "Crust was flaky and delicious. Will try the berry flavor next time."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Cake",
        price: 17,
        disprice: 13,
        stock: 0,
        content: "Moist and delicious cakes, perfect for celebrations or a sweet indulgence anytime.",
        description: "Our cakes are crafted with the finest ingredients, offering a soft, fluffy texture and rich flavors. Whether it’s a classic vanilla, decadent chocolate, or fruity strawberry cake, each one is freshly baked to satisfy your sweet tooth. Ideal for birthdays, parties, or as a special treat.",
        category: ["Sweet Treats", "Dessert Delights"],
        tags: ["sweet", "baked", "classic"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavors", content: "Vanilla, Chocolate, Strawberry" },
            { id: 2, title: "Layers", content: "2-Layer and 3-Layer Options" },
            { id: 3, title: "Allergens", content: "Contains Eggs, Dairy, Gluten" },
            { id: 4, title: "Shelf Life", content: "3 Days (Refrigerated)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Amina Tariq",
                date: "June 30, 2025",
                rating: 5,
                content: "Ordered the chocolate cake for my son's birthday—everyone loved it!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Bilal Raza",
                date: "June 30, 2025",
                rating: 4.5,
                content: "Moist and flavorful. Will definitely order again for our next family gathering."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Croissant",
        price: 9,
        disprice: 7,
        stock: 15,
        content: "Flaky and buttery croissants, freshly baked to golden perfection for a delightful start to your day.",
        description: "Our croissants are made using traditional French techniques, featuring multiple layers of buttery pastry dough that create a crisp exterior and soft, airy interior. Perfect for breakfast, brunch, or an afternoon snack, they pair wonderfully with coffee or jam.",
        category: ["Bakery Items", "Savory Snacks"],
        tags: ["baked", "classic", "sweet"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Type", content: "Classic, Almond, Chocolate" },
            { id: 2, title: "Texture", content: "Crispy outside, soft inside" },
            { id: 3, title: "Allergens", content: "Contains Gluten, Dairy" },
            { id: 4, title: "Shelf Life", content: "2 Days (Room Temperature)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Sarah Ali",
                date: "June 30, 2025",
                rating: 5,
                content: "The best croissants I’ve had outside of Paris. So flaky and fresh!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Ahmed Qureshi",
                date: "June 30, 2025",
                rating: 4.5,
                content: "Perfectly buttery and soft. A great morning treat with coffee."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Sweet Pancake",
        price: 11,
        disprice: 9,
        stock: 18,
        content: "Soft and fluffy sweet pancakes, drizzled with syrup and topped with your favorite fruits for the perfect breakfast treat.",
        description: "Our sweet pancakes are made from a rich batter, cooked to golden perfection, and served warm. Each bite melts in your mouth with a soft, airy texture and just the right touch of sweetness. Customize with toppings like maple syrup, fresh berries, or chocolate chips for an indulgent breakfast or brunch delight.",
        category: ["Sweet Treats", "Bakery Items"],
        tags: ["sweet", "baked", "classic"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavor Options", content: "Classic, Chocolate Chip, Blueberry" },
            { id: 2, title: "Serving Size", content: "2-3 Pancakes per serving" },
            { id: 3, title: "Allergens", content: "Contains Gluten, Dairy, Eggs" },
            { id: 4, title: "Best Served", content: "Hot, with syrup or fruits" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Emma Khan",
                date: "July 1, 2025",
                rating: 5,
                content: "Fluffy and delicious! The perfect start to my morning."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Ali Raza",
                date: "July 1, 2025",
                rating: 4.8,
                content: "Loved the blueberry pancakes! Fresh and sweet."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Fruit Smoothie",
        price: 12,
        disprice: 9,
        stock: 20,
        content: "Refreshing fruit smoothie made from a blend of fresh fruits and natural yogurt for a healthy and energizing treat.",
        description: "Our fruit smoothie is packed with the goodness of fresh fruits like bananas, berries, and mangoes blended with creamy yogurt and a touch of honey. Perfect for a breakfast boost or midday refreshment, this smoothie is rich in vitamins and antioxidants to keep you energized throughout the day.",
        category: ["Healthy Beverages", "Sweet Treats"],
        tags: ["fruit", "sweet", "classic"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavors", content: "Berry Blast, Mango Delight, Banana Boost" },
            { id: 2, title: "Serving Size", content: "350ml per cup" },
            { id: 3, title: "Allergens", content: "Contains Dairy" },
            { id: 4, title: "Best Served", content: "Chilled" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Sarah Ahmed",
                date: "July 1, 2025",
                rating: 5,
                content: "Fresh, fruity, and just the right amount of sweetness. Loved it!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Omar Siddiqui",
                date: "July 1, 2025",
                rating: 4.7,
                content: "The mango smoothie was amazing. Will order again!"
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Classic Sandwich",
        price: 12,
        disprice: 10,
        stock: 15,
        content: "A timeless favorite, our Classic Sandwich is crafted with fresh bread, crisp vegetables, and savory fillings for the perfect meal or snack.",
        description: "The Classic Sandwich features layers of fresh lettuce, ripe tomatoes, cheese, and your choice of turkey, chicken, or veggie filling, all stacked between two slices of freshly baked bread. Ideal for lunch breaks or casual dining, this sandwich delivers a satisfying bite full of flavor and freshness.",
        category: ["Savory Snacks", "Bakery Items"],
        tags: ["classic", "baked", "sweet"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Fillings", content: "Turkey, Chicken, Veggie" },
            { id: 2, title: "Bread Type", content: "Whole Wheat, White, Multigrain" },
            { id: 3, title: "Serving Size", content: "1 Sandwich" },
            { id: 4, title: "Allergens", content: "Contains Gluten & Dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Ali Raza",
                date: "July 2, 2025",
                rating: 4.8,
                content: "Fresh ingredients and tasty filling. My go-to lunch option!"
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Fatima Noor",
                date: "July 3, 2025",
                rating: 4.5,
                content: "Simple yet delicious. Loved the fresh bread!"
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Fresh Bread",
        price: 10,
        disprice: 8,
        stock: 20,
        content: "Our Fresh Bread is baked daily, offering a soft texture and rich aroma perfect for sandwiches, toast, or enjoying on its own.",
        description: "Made from premium flour and natural ingredients, our Fresh Bread features a golden crust and fluffy interior. Whether you prefer it as a breakfast staple or part of your dinner table, this bread complements every meal with its wholesome taste and texture.",
        category: ["Bakery Items", "Savory Snacks"],
        tags: ["baked", "classic", "sweet"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Wheat Flour, Yeast, Salt, Water" },
            { id: 2, title: "Net Weight", content: "500g" },
            { id: 3, title: "Baking Time", content: "45 Minutes" },
            { id: 4, title: "Allergens", content: "Contains Gluten" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Sarah Khan",
                date: "July 4, 2025",
                rating: 5,
                content: "So fresh and soft, it’s the best bread I’ve tasted in a while!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Hamza Ali",
                date: "July 5, 2025",
                rating: 4.7,
                content: "Perfect for my sandwiches. Loved the aroma!"
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "French Macaron",
        price: 12,
        disprice: 10,
        stock: 25,
        content: "Delicate and colorful French Macarons with crisp shells and creamy fillings, perfect for adding elegance to any occasion.",
        description: "Handcrafted using almond flour and filled with rich buttercream or ganache, our French Macarons offer a delightful balance of sweetness and texture. Available in assorted flavors, they make a charming addition to dessert tables, gift boxes, or personal treats.",
        category: ["Dessert Delights", "Sweet Treats"],
        tags: ["sweet", "baked", "classic"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavors", content: "Vanilla, Chocolate, Raspberry, Pistachio" },
            { id: 2, title: "Ingredients", content: "Almond Flour, Egg Whites, Sugar, Buttercream" },
            { id: 3, title: "Shelf Life", content: "3 Days Refrigerated" },
            { id: 4, title: "Allergens", content: "Contains Nuts, Eggs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Emily Clark",
                date: "July 6, 2025",
                rating: 5,
                content: "Absolutely delicious! The texture was perfect and the flavors were divine."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Omar Yusuf",
                date: "July 7, 2025",
                rating: 4.8,
                content: "Beautifully made and so flavorful. A must-try!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Choco Brownie",
        price: 10,
        disprice: 8,
        stock: 20,
        content: "Rich and fudgy Choco Brownies, baked to perfection for chocolate lovers seeking the ultimate indulgence.",
        description: "Our Choco Brownies are crafted with premium cocoa, melted chocolate, and real butter to create a dense, moist texture and an intense chocolate flavor. Ideal for dessert platters, gift boxes, or personal treats, these brownies satisfy every sweet craving.",
        category: ["Sweet Treats", "Dessert Delights"],
        tags: ["chocolate", "sweet", "baked"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Main Ingredients", content: "Cocoa, Butter, Sugar, Eggs, Flour" },
            { id: 2, title: "Serving Size", content: "Single or Pack of 4" },
            { id: 3, title: "Shelf Life", content: "4 Days" },
            { id: 4, title: "Allergens", content: "Contains Eggs, Dairy, Gluten" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Sana Malik",
                date: "July 8, 2025",
                rating: 5,
                content: "These brownies are heavenly! Rich, moist, and perfectly chocolatey."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Alex Reed",
                date: "July 9, 2025",
                rating: 4.7,
                content: "Super satisfying. Loved the fudgy center!"
            }
        ]
    }

];

export default products;